import React, { useMemo } from "react";
import { fieldTypes } from "../../constants";
import FieldSet from "./FieldSet";
import { Typography } from "../../atoms";

export function HintAndTerms({
  fields,
  hint = { local: "Hint" },
  ...fieldSetProps
}) {
  const termFields = useMemo(
    () =>
      fields
        ? fields.filter((f) => !f.hidden && f.type === fieldTypes.TERMS)
        : [],
    [fields]
  );

  return (
    <div className="my-4">
      <div className="mb-1">
        <Typography.P
          content={hint}
          className="text-xs text-gray-500 dark:text-gray-400"
        />
      </div>
      {termFields.length > 0 && (
        <FieldSet fields={termFields} {...fieldSetProps} />
      )}
    </div>
  );
}
